
import { _showAppLogs } from "global/cnr/contexts/LogContext";
import { cacheDataManager } from "global/cnr/contexts/useHelpers/useCacheDataManager";
import { firebaseHelpers } from "global/cnr/reducers/reducerHelpers/firebaseHelpers";

const _getLocalCache = false

export const loadManifest = async () => {

  const { clientKey, eventKey } = parseKeysFromHash();
  const manifestKey = getManifestKey({ clientKey, eventKey });

  const cache_groupType = 'manifests'

  let manifest;
  let manifestFromCache = false;

  const manifest_cached = await cacheDataManager.getSubItem(cache_groupType, manifestKey);
  const { _timestamp: _timestamp_cached } = manifest_cached ?? {}

  // 1️⃣ Try reading from cache
  if (manifest_cached && _getLocalCache) {
    manifest = manifest_cached
    manifestFromCache = true;
    _showAppLogs.manifest && console.log(`♻️🧾 Loaded manifest-${manifestKey} from cache`);
    manifest.start_url = window.document.URL
  }

  // 2️⃣ Fallback: fetch from Firebase
  if (!manifest) {
    manifest = await firebaseHelpers.getManifestFromFirebaseSettings(clientKey, eventKey);
    manifest.start_url = window.document.URL
    _showAppLogs.manifest && console.log('🌐🧾 Fetched manifest from Firebase', manifest);
    const ts_update = Date.now()
    await cacheDataManager.mergeToGroup(cache_groupType, manifestKey, manifest, ts_update);
  }

  console.log('manifest', manifest)

  // 3️⃣ Apply manifest
  if (manifest) {
    applyManifest(manifest);

    // 🧠 Update favicon
    if (manifest?.icons?.length) {
      const sortedIcons = [...manifest.icons].sort((a, b) => {
        const getSize = (s) => parseInt(s.sizes?.split('x')[0]) || 0;
        return getSize(b) - getSize(a);
      });

      const bestIcon = sortedIcons[0]?.src;
      if (bestIcon) {
        // Remove old icons
        document.querySelectorAll("link[rel~='icon']").forEach(el => el.remove());
        // Favicon
        const favicon = document.createElement("link");
        favicon.rel = "icon";
        favicon.href = bestIcon;
        favicon.type = "image/png";
        document.head.appendChild(favicon);
        // Apple touch icon
        const appleTouch = document.createElement("link");
        appleTouch.rel = "apple-touch-icon";
        appleTouch.href = bestIcon;
        document.head.appendChild(appleTouch);
      }
    }
    // 🧩 Update page title
    if (manifest?.short_name || manifest?.name) {
      document.title = manifest.name || manifest.short_name;
      if (document.title === 'name') {
        document.title = 'ME'
      }
    }
  }


  return { manifest, manifestFromCache };
};


// Optional: move this too if it's reusable
async function applyManifest(manifest) {
  const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' });
  const url = URL.createObjectURL(blob);

  // let link = document.getElementById('dynamic-manifest');
  // if (!link) {
  //   link = document.createElement('link');
  //   link.rel = 'manifest';
  //   link.id = 'dynamic-manifest';
  //   document.head.appendChild(link);
  // }
  // link.href = url;

  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = url;
  document.head.appendChild(link);
};

export function parseKeysFromHash() {
  const hash = window.location.hash;
  // example: #/clients/CLIENT123/events/EVENT456/...
  const parts = hash.split('/');
  const clientIndex = parts.indexOf('clients');
  const eventIndex = parts.indexOf('events');
  return {
    clientKey: clientIndex !== -1 ? parts[clientIndex + 1] : null,
    eventKey: eventIndex !== -1 ? parts[eventIndex + 1] : null,
  };
}

/**
 * Get which manifest key should be used based on the current URL.
 */
export function getManifestKey({ clientKey, eventKey }) {
  if (eventKey) return eventKey;
  if (clientKey) return clientKey;
  return 'home';
} 